import { jsx as _jsx } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgFacebookShare = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    d: "M20.417 6.604a9.98 9.98 0 0 0-4.24-3.69c-1.74-.8-3.66-1.08-5.56-.82a9.977 9.977 0 0 0-8.19 7 10.04 10.04 0 0 0-.05 5.62 9.992 9.992 0 0 0 8.06 7.16v-6.99h-2.54v-2.89h2.54v-2.2c0-2.51 1.49-3.89 3.78-3.89.75.01 1.5.07 2.24.19v2.46h-1.26a1.31 1.31 0 0 0-.28 0c-.11.01-.21.03-.31.07-.21.07-.39.18-.55.33-.16.15-.28.33-.35.54-.08.2-.11.42-.09.64v1.87h2.73l-.45 2.89h-2.33v6.99c2.35-.37 4.5-1.57 6.04-3.38a9.937 9.937 0 0 0 2.39-6.5c0-1.91-.55-3.78-1.58-5.39v-.01Z"
  })
});
export default SvgFacebookShare;